// extracted by mini-css-extract-plugin
module.exports = {"indicator":"menubar_indicator__dHRUs","caret":"menubar_caret__26_wK"};